import script from "./StudioDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./StudioDashboard.vue?vue&type=script&setup=true&lang=js"

import "./StudioDashboard.vue?vue&type=style&index=0&id=7403cee4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7403cee4"]])

export default __exports__